import React from 'react';
import {Box} from '@mui/material';
import {times} from 'lodash';

const Loading = (): React.ReactElement => (
  <Box mt={3} data-testid="hallway-monitor-loading">
    {times(10, (number) => (
      <div className="shared-shimmer-text" key={number} />
    ))}
  </Box>
);

export default Loading;
